var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5593_1759)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2668 3.7334V14.9307H78.1748V3.7334H80.2668Z",
    fill: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2266 12.0496L69.3755 14.9336H67.2002L70.8493 3.73633H73.3673L77.0001 14.9336H74.7133L73.8595 12.0552H70.2266V12.0496ZM73.4301 10.4036L72.0977 5.87598H72.0052L70.6729 10.4036H73.4301Z",
    fill: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5V60.375V74.1333C0 79.5825 4.41747 84 9.86668 84H71.8846C75.0978 84 78.1794 82.8938 80.4515 80.9246C82.7236 78.9555 84 76.2848 84 73.5V18.6667H77.9423H66.7556C64.9392 18.6667 63.4667 17.1942 63.4667 15.3778V0H12.1154C8.90218 0 5.82059 1.10625 3.54852 3.07538C1.27644 5.04451 0 7.71523 0 10.5Z",
    fill: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.178 29.724L41.718 54H38.624L33.898 38.088C33.762 37.612 33.626 37.1247 33.49 36.626C33.354 36.1273 33.2293 35.6513 33.116 35.198C33.0027 34.7447 32.9007 34.3593 32.81 34.042C32.742 33.702 32.6967 33.4527 32.674 33.294C32.6513 33.4527 32.606 33.702 32.538 34.042C32.4927 34.3593 32.4133 34.7447 32.3 35.198C32.1867 35.6513 32.062 36.1387 31.926 36.66C31.8127 37.1587 31.6767 37.6687 31.518 38.19L26.928 54H23.834L17.408 29.724H20.604L24.378 44.548C24.514 45.0693 24.6387 45.5907 24.752 46.112C24.8653 46.6107 24.9673 47.1093 25.058 47.608C25.1713 48.084 25.262 48.5487 25.33 49.002C25.398 49.4553 25.466 49.8973 25.534 50.328C25.602 49.8747 25.67 49.41 25.738 48.934C25.8287 48.458 25.9307 47.9707 26.044 47.472C26.1573 46.9507 26.282 46.4293 26.418 45.908C26.554 45.3867 26.69 44.8767 26.826 44.378L31.11 29.724H34.272L38.726 44.48C38.8847 45.0013 39.032 45.534 39.168 46.078C39.304 46.5993 39.4287 47.1093 39.542 47.608C39.6553 48.1067 39.746 48.594 39.814 49.07C39.9047 49.5233 39.984 49.9427 40.052 50.328C40.12 49.7613 40.2107 49.172 40.324 48.56C40.4373 47.9253 40.5733 47.268 40.732 46.588C40.8907 45.908 41.0607 45.2167 41.242 44.514L44.982 29.724H48.178ZM65.4734 54H51.9074V29.724H65.4734V32.41H54.9674V39.992H64.8614V42.644H54.9674V51.314H65.4734V54Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5593_1759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLogo);
export default __webpack_public_path__ + "static/media/WE_Logo.a3b23605ccce44f36c2fb30c0e7117a7.svg";
export { ForwardRef as ReactComponent };